import { Loader2, Minus, Plus, Trash2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const SIZES = {
  sm: { wrap: 'h-9 md:h-10', btn: 'w-9 md:w-10', icon: 'w-4 h-4', text: 'text-sm md:text-base' },
  lg: { wrap: 'h-14', btn: 'w-12', icon: 'w-5 h-5', text: 'text-lg' },
};

/**
 * عدّاد كمية مربوط بالسلة: (+) الكمية (−) — ولما الكمية 1 زر التقليل بيبقى "حذف".
 * label: نص اختياري جنب الرقم (مثلاً "في السلة").
 */
const CartStepper = ({ quantity, onIncrement, onDecrement, canIncrement = true, busy = false, size = 'sm', label, className }) => {
  const s = SIZES[size];
  const removing = quantity <= 1;

  return (
    <div
      className={cn(
        'inline-flex items-stretch rounded-full bg-burgundy-500 text-white shadow-md shadow-burgundy-500/20 overflow-hidden select-none',
        s.wrap,
        className
      )}
      role="group"
      aria-label="الكمية في السلة"
    >
      <button
        type="button"
        onClick={onIncrement}
        disabled={busy || !canIncrement}
        aria-label="زيادة الكمية"
        title={canIncrement ? 'زيادة الكمية' : 'وصلتِ للحد الأقصى'}
        className={cn('shrink-0 flex items-center justify-center hover:bg-white/15 active:bg-white/25 transition-colors disabled:opacity-40 disabled:cursor-not-allowed', s.btn)}
      >
        <Plus className={s.icon} />
      </button>

      <span className={cn('flex-1 min-w-7 flex items-center justify-center gap-1.5 font-bold tabular-nums font-cairo', s.text)} aria-live="polite">
        {busy ? <Loader2 className={cn(s.icon, 'animate-spin')} /> : quantity}
        {label && !busy && <span className="font-semibold text-white/85 text-xs md:text-sm">{label}</span>}
      </span>

      <button
        type="button"
        onClick={onDecrement}
        disabled={busy}
        aria-label={removing ? 'إزالة من السلة' : 'تقليل الكمية'}
        title={removing ? 'إزالة من السلة' : 'تقليل الكمية'}
        className={cn('shrink-0 flex items-center justify-center hover:bg-white/15 active:bg-white/25 transition-colors disabled:opacity-40', s.btn)}
      >
        {removing ? <Trash2 className={s.icon} /> : <Minus className={s.icon} />}
      </button>
    </div>
  );
};

export default CartStepper;
